import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const getMenu = async () => {
    try {
        const docSnap = await getDoc(doc(db, 'StatusFindep', 'menu'));
        if (docSnap.exists()) {
            return [
                {
                    text: 'Resumen',
                    icon: 'Dvr',
                    to: '/',
                },
                ...docSnap.data().menu,
            ];
        } else {
            return {
                error: 'No se encontro información para el menu',
            };
        }
    } catch (error) {
        return {
            error: 'Ocurrió un problema, intentalo más tarde',
        };
    }
};

export const getRouterStructure = async () => {
    try {
        const docSnap = await getDoc(doc(db, 'StatusFindep', 'router'));
        if (docSnap.exists()) {
            return docSnap.data().router;
        } else {
            return {
                error: 'No se encontro información para la estructura del router',
            }
        }
    } catch (error) {
        return {
            error: 'Ocurrió un problema, intentalo más tarde',
        }
    }
};